<template>
    <div>
        <div class="modal fade" id="retiro" tabindex="-1" aria-labelledby="myAccountZeusLabel" aria-hidden="true"
            data-bs-backdrop="false">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" :style="skin.header_desktop.nav_bar1">
                    <div class="modal-body p-4" style="font-family: 'Exo 2', sans-serif !important;">
                        <div class="container">
                            <!-- <button id="closemyAccountZeus" :style="skin.my_account.close_btn"
                                    style="background:transparent;float: right;color:white" type="button" class="btn-close"
                                    data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button> -->
                            <h3 style="color: white;"><span class="fa fa-table mb-3"></span>
                                Historial de Retiros</h3>
                            <div class="row">
                                <div class="col-md-2 col-sm-12 mb-2">
                                    <select v-model="filter" name="" id="" class="input-custom">
                                        <option value="3">Todos</option>
                                        <option value="0">Pendientes</option>
                                        <option value="1">Aprobados</option>
                                        <option value="2">Rechazados</option>
                                    </select>
                                </div>
                            </div>
                            <div class="table-responsive my-3">
                                <table v-if="!loading && solicitudes.length > 0" class="table"
                                    style="color:white;font-size: 15px;">
                                    <thead :style="{ 'color': skin.main_modal_background }">
                                        <tr>
                                            <th scope="col">Fecha de Solicitud</th>
                                            <th scope="col">Fecha de Aceptación</th>
                                            <th scope="col">Valor</th>
                                            <th scope="col">Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="solicitud in paginarArray(solicitudesFiltered, registers_per_page)[actual_page - 1]"
                                            :key="solicitud.id">
                                            <td>{{ formatDate(solicitud.created_at) }} </td>
                                            <td>{{ formatDate(solicitud.updated_at) }}</td>
                                            <td>{{ new Intl.NumberFormat("de-DE", {
                                                minimumFractionDigits:
                                                    skin.qBet_config.decimalsQty, maximumFractionDigits:
                                                skin.qBet_config.decimalsQty}).format(solicitud.valor) }}</td>
                                            <td>{{ mapEstado(solicitud.estado) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="solicitudesFiltered.length < 1" class="text-center"
                                    style="font-size: 3em;color: white; font-family:'passionone-bold',sans-serif !important;">
                                    <span>{{ translate('found') }}</span>
                                </div>
                            </div>
                            <div>
                                <pagination class="float-end" :options="paginationConf" v-model="actual_page"
                                    :records="records" :per-page="registers_per_page" @paginate="paginate" />
                            </div>
                        </div>
                        <br><br><br>
                        <div class="text-center">
                            <button class="btn"
                                :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                style="font-size: small;font-weight: bold;text-transform: uppercase;"
                                data-bs-dismiss="modal" aria-label="Close">{{ translate('close') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from 'vue-pagination-2';
import MyPagination from './Pagination.vue'
import axios from 'axios';
export default {
    name: "myAccountZeus",
    props: ['skin', 'translation', 'language'],
    components: { Pagination },
    data() {
        return {
            solicitudes: [],
            solicitudesFiltered: [],
            filter: 3,
            actual_page: 1,
            records: 0,
            registers_per_page: 10,
            paginationConf: {
                texts: { count: '' },
                template: MyPagination
            },
            loading: true
        }
    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        apiUrlnew() {
            return this.$store.getters['getApiUrlnew'];
        },
        site() {
            return this.$store.getters['getSite'];
        }
    },
    methods: {
        paginate(page) {
            this.actual_page = page;
        },
        paginarArray(array, elementosPorPagina) {
            const paginas = [];
            let paginaActual = [];

            for (let i = 0; i < array.length; i++) {
                if (paginaActual.length === elementosPorPagina) {
                    paginas.push(paginaActual);
                    paginaActual = [];
                }
                paginaActual.push(array[i]);
            }

            if (paginaActual.length > 0) {
                paginas.push(paginaActual);
            }
            this.records = array.length;
            this.pages = paginas;
            return paginas;
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        async fetchSolicitudes() {
            try {
                const value = sessionStorage.getItem('setApiHostnew');
                const response = await axios.get(value + 'get_solicitud', {
                    params: {
                        "login_Id": this.user?.user_data?.data?.user_id,
                        "token": this.user.token,
                    }
                });
                this.solicitudes = response.data;// Asigna los datos de la API
                this.solicitudesFiltered = response.data;

            } catch (error) {
                console.error("Error al obtener las solicitudes:", error);
            } finally {
                this.loading = false; // Finaliza la carga
            }
        },
        formatDate(dateString) {
            if (!dateString) return "No disponible";
            const date = new Date(dateString);
            return date.toLocaleDateString("es-ES", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        },
        mapEstado(estado) {
            switch (estado) {
                case 0:
                    return "Pendiente";
                case 1:
                    return "Aprobado";
                case 2:
                    return "Rechazado";
                case 3:
                    return "Todos";
                default:
                    return "Desconocido"; // Opcional, por si se recibe un estado no esperado
            }
        },
    },
    mounted() {
        this.fetchSolicitudes();
    },

    watch: {
        filter(newValue) {
            newValue= parseInt(newValue);
            if (newValue === 3) {
                // Si se selecciona "Todo", no se aplica ningún filtro
                this.solicitudesFiltered = this.solicitudes;
            } else {
                // Filtra las solicitudes basadas en el estado
                this.solicitudesFiltered = this.solicitudes.filter(
                    (solicitud) => solicitud.estado === newValue
                );
            }
        }
    }
}
</script>

<style scoped>
.input-bets {
    background-color: #161616 !important;
    font-size: 1rem !important;
    color: #fff !important;
    border-color: #383c61 !important;
}

.input-custom {
    font-size: 1rem;
    background-color: #2e2e2e;
    color: #fff;
    border-radius: 6px;
    padding: 10px 20px;
    line-height: .75em;
    width: 100%;
    border: 1px solid rgba(22, 22, 22, .082);
}
</style>